module.exports = __webpack_public_path__ + "static/img/zyc22.f0774cb4.png";